import {
  TracksFill18Icon,
  TracksOutline18Icon,
  WarningFill18Icon,
} from "@vygruppen/spor-icon-react";
import styled from "styled-components";

const IconContainer = styled.span`
  position: relative;
  display: flex;
  max-width: min-content;
  margin-top: auto;
  margin-bottom: auto;
`;

const StyledWarningIcon = styled(WarningFill18Icon)`
  position: absolute;
  right: -4px;
  bottom: -2px;
`;

export const InfrastructureIncidentIcon18 = () => (
  <IconContainer>
    <TracksOutline18Icon />
    <StyledWarningIcon height="12px" fill="black" />
  </IconContainer>
);

export const InfrastructureIncidentIconTabsActive = () => (
  <IconContainer>
    <TracksFill18Icon />
    <StyledWarningIcon height="12px" fill="black" />
  </IconContainer>
);
